// AnimatedText.js
import React from "react";
import '../styles/Textanimation.css';
import { useInView } from "react-intersection-observer";
// import styles from "../../styles/AnimatedText.module.css";
const AnimatedText6 = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // animate only once when it first comes into view
    threshold: 0.1,    // trigger when 10% of the component is in view
  });
  return (

    <div ref={ref} className={`container ${inView ? "animate" : ""}`} style={{justifyContent:"flex-start",padding:"0"}}>
      <div className="text a"> The work </div>
      <div className="text b"> at a </div>
      <div className="text c"> glance,  </div>
      <div className="text d"> that's </div>
      <div className="text e"> scaling </div>
      <div className="text f"> brands </div>
      <div className="text g"> to 9 </div>
      <div className="text h"> figures </div>
      <div className="text i"> and beyond. </div>
    </div>
  );
};
export default AnimatedText6;